var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnassigned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6147 17.9799L19.764 16.8306C20.2241 16.3705 20.2241 15.6814 19.764 15.2212C19.3038 14.7622 18.6147 14.7622 18.1545 15.2212L17.0053 16.3705L15.856 15.2212C15.397 14.7622 14.7068 14.7622 14.2466 15.2212C13.7876 15.6814 13.7876 16.3705 14.2466 16.8306L15.397 17.9799L14.3622 19.0147C13.9021 19.4737 13.9021 20.1639 14.3622 20.623C14.8212 21.0831 15.5115 21.0831 15.9716 20.623L17.0053 19.5893L18.1545 20.7386C18.3846 20.9686 18.7292 21.0831 18.9593 21.0831C19.1893 21.0831 19.5339 20.9686 19.764 20.7386C20.2241 20.2784 20.2241 19.5893 19.764 19.1292L18.6147 17.9799Z",
    fill: "#E99514"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5472 7.28922C16.6617 4.41608 14.2487 2.00195 11.26 2.00195C8.27117 2.00195 5.97266 4.41608 5.97266 7.28922C5.97266 10.278 8.38678 12.5765 11.26 12.5765C14.2487 12.5765 16.5472 10.1624 16.5472 7.28922Z",
    fill: "#E99514"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1115 14.877C8.50212 14.877 7.00831 15.107 5.85905 15.4516C5.16881 15.6817 4.47971 16.0262 4.01955 16.4864C3.56053 16.9454 3.21484 17.6356 3.21484 18.4403C3.21484 19.245 3.44492 19.8197 4.01955 20.3943C4.47971 20.8533 5.16881 21.199 5.85905 21.428C7.00831 21.7736 8.50212 22.0026 10.1115 22.0026C10.8006 22.0026 11.2608 21.5436 11.2608 20.8533V16.0262C11.2608 15.3371 10.8006 14.877 10.1115 14.877Z",
    fill: "#E99514"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassigned);
export default __webpack_public_path__ + "static/media/unassigned.cb98476e9cb2f9f722766e1a7fc7e267.svg";
export { ForwardRef as ReactComponent };